import { useMemo } from "react";
import { GetOrderStatsResponse } from "api/companies/getOrderStats";
import { useGetAllCompaniesQuery, useGetCompanyOrderStatsQuery } from "app/api/companies";
import { Company } from "models/Company";

export type CompanyWithOrderStats =
  Company
  & Omit<GetOrderStatsResponse[number], "companyId" | "companyName">
  & { isLoadingStats: boolean };

export function useCompaniesWithStats(): { companies: CompanyWithOrderStats[]; isLoading: boolean; isLoadingOrderStats: boolean } {
  const { data: companies, isLoading } = useGetAllCompaniesQuery();
  const { data: orderStats, isLoading: isLoadingOrderStats } = useGetCompanyOrderStatsQuery();

  const mappedOrderStats = useMemo(() => new Map(orderStats?.map((stat) => [stat.companyId, stat])), [orderStats]);

  const companiesWithStats = (companies || []).map((company) => {
    const stats = mappedOrderStats.get(company.id);
    return {
      ...company,
      totalOrders: stats?.totalOrders || 0,
      ordersLastYear: stats?.ordersLastYear || 0,
      isLoadingStats: isLoadingOrderStats,
    };
  });

  return { companies: companiesWithStats, isLoading, isLoadingOrderStats };
}
